const icon = state => state.icon;
const plantsWithoutStatInsp = state => state.plantsWithoutStatInsp;
const statInsps = state => state.statInsps;
const statInsp = state => state.statInsp;
const statInspItems = state => state.statInspItems;
const statInspItem = state => state.statInspItem;
const statInspItemTypes = state => state.statInspItemTypes;
const statInspItemStatuses = state => state.statInspItemStatuses;
const statInspItemTimePeriods = state => state.statInspItemTimePeriods;
const statInspItemEligibleForClosure = state => {
  return state.statInspItems.filter(li =>
    [2, 5].includes(li.statInspItemStatusId)
  );
};
const statInspItemNotEligibleForClosure = state => {
  return state.statInspItems.filter(li =>
    [1, 3, 4, 6, 7].includes(li.statInspItemStatusId)
  );
};
const isEditable = state =>
  state.statInsp.isActive && !state.statInsp.isPartial;
const statInspItemStatus = state => statInspItemStatusId => {
  return state.statInspItemStatuses.find(li => li.id === statInspItemStatusId);
};
const statInspItemType = state => statInspItemTypeId => {
  return state.statInspItemTypes.find(li => li.id === statInspItemTypeId).name;
};
const statInspItemTimePeriod = state => statInspItemTimePeriodId => {
  return state.statInspItemTimePeriods.find(
    li => li.id === statInspItemTimePeriodId
  ).name;
};

const statPagedInspItemsResult = state => state.statPagedInspItems;
const statInspItemQuote = state => state.statInspItem.liveQuote;
const statInspItemPreviousQuotes = state => state.statInspItem.previousQuotes;

export default {
  icon,
  plantsWithoutStatInsp,
  statInsps,
  statInsp,
  statInspItems,
  statInspItem,
  statInspItemTypes,
  statInspItemTimePeriods,
  statInspItemEligibleForClosure,
  statInspItemNotEligibleForClosure,
  isEditable,
  statInspItemStatus,
  statInspItemType,
  statInspItemTimePeriod,
  statInspItemStatuses,
  statPagedInspItemsResult,
  statInspItemQuote,
  statInspItemPreviousQuotes
};
